import { Heading } from 'native-base';
import React, { memo } from 'react';
const CenteredSubTitle = _ref => {
  let {
    title
  } = _ref;
  return /*#__PURE__*/React.createElement(Heading, {
    textAlign: "center",
    fontWeight: "300",
    color: "#222A34",
    testID: `heading-${title.toLowerCase()}`,
    my: {
      base: '5',
      md: '3%',
      lg: '3%'
    },
    fontSize: {
      base: '2xl',
      md: '2xl',
      lg: '3xl'
    },
    accessibilityLabel: title,
    accessibilityRole: 'header'
  }, title);
};
export default /*#__PURE__*/memo(CenteredSubTitle);
//# sourceMappingURL=index.js.map